import {pageLinksAtom} from '@state'

import React from 'react'

import {useAtomValue} from 'jotai'
import {Outlet} from 'react-router-dom'

import {SideNavigation, TopBar, UIKit} from '@components'

import {Background, RightSideWrapper, ContentWrapper, SideNavigationWrapper} from './style'

/**
 * Page wrapper with side navigation
 */
export function PageWrapper() {
  const links = useAtomValue(pageLinksAtom)

  return (
    <Background direction={'row'}>
      <SideNavigationWrapper>
        <SideNavigation />
      </SideNavigationWrapper>
      <RightSideWrapper>
        <UIKit.LoaderOverlay />
        <TopBar links={links || []} />
        <ContentWrapper gap={5}>
          <Outlet />
        </ContentWrapper>
      </RightSideWrapper>
    </Background>
  )
}
